<cli-topbar></cli-topbar>
<cli-navbar [hidden]="vm.isOpening" [selectedSection]="'overview'" [businessName]="vm.businessName"
    [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" [hidden]="vm.isOpening">
    <div class="row">
        <div class="col-md-6 account">
            <div class="row section-header  mt-4">
                <div class="col">Account</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Permit Number</div>
                <div class="ml-auto">{{vm.permitNo}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Permit Activation Date</div>
                <div class="ml-auto">{{vm.startDate | date:"dd/MM/yyyy"}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Customer Number</div>
                <div class="ml-auto">{{vm.customerNo}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Business Name</div>
                <div class="ml-auto">{{vm.businessName}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">ABN</div>
                <div class="ml-auto">{{vm.abn}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Permit Holder</div>
                <div class="ml-auto">{{vm.contactName}}</div>
            </div>

            <div class="d-flex">
                <div class="mr-1 small mb-2">Email</div>
                <div class="ml-auto">{{vm.email}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Primary Phone Number</div>
                <div class="ml-auto">{{vm.primaryPhone}}</div>
            </div>
            <div class="d-flex">
                <div class="mr-1 small mb-2">Address</div>
                <div class="ml-auto">{{vm.fullAddress}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-8 small mb-2"></div>
                <div class="col-4 text-right"><a routerLink="/app/account">Update Details</a></div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row mt-4">
                <div class="col  section-header">Vehicles</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="pb-2">
                <div class="row" *ngIf="vm.status=='Cancelled'">
                    <div class="col">The permit is <b>Inactive</b></div>
                </div>

                <div class="row" *ngIf="vm.status=='Active' && vm.isExpired">
                    <div class="col">The permit has expired. Please renew.</div>
                </div>

                <div class="row" *ngIf="vm.backflowPreventionExpiredAlready>0">
                    <div class="col">You have <b>{{vm.backflowPreventionExpiredAlready}}</b> backflow prevention device
                        certificate expired
                    </div>
                </div>
                <div class="row" *ngIf="vm.backflowPreventionExpiresSoon>0">
                    <div class="col">You have <b>{{vm.backflowPreventionExpiresSoon}}</b> backflow prevention device
                        certificate that will expire soon
                    </div>
                </div>
                <div class="row" *ngIf="vm.status=='Active' && vm.isExpired">
                    <div class="col">You have <b>{{vm.vehicleCount}}</b> vehicle(s) that have expired on
                        <b>{{vm.expiryDate | date:"dd/MM/yyyy"}}</b>
                    </div>
                </div>
                <div class="row" *ngIf="vm.status=='Active' && !vm.isExpired">
                    <div class="col">You have <b>{{vm.vehicleCount}}</b> vehicle(s) that will expire on
                        <b>{{vm.expiryDate | date:"dd/MM/yyyy"}}</b>
                    </div>
                </div>
            </div>
            <div class="row pl-3 pb-2 section-header small ">Active Vehicles</div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="row  table " *ngIf="vehicles && vehicles.length> 0">

                <div class="col-12 ">
                    <div class="row pb-1">
                        <div class="col-md-3 font-weight-bold d-flex">
                            <div>Reg No</div>
                        </div>
                        <div class="col-md-3 font-weight-bold d-flex">
                            <div>Capacity</div>
                        </div>
                        <div class="col-md-3 font-weight-bold d-flex">
                            <div>Vehicle Type</div>
                        </div>
                        <div class="col-md-3 font-weight-bold  d-flex">
                            <div>Permit Fee</div>
                        </div>
                    </div>
                    <div>
                        <hr class="mt-0 mb-1" />
                    </div>
                    <div class="row pb-1" *ngFor="let v of vehicles; let i = index"
                        [ngClass]="i%2==0 ? '' : 'bg-light'">
                        <div class="col-md-3 pr-5">{{v.regoNumber}}&nbsp;</div>
                        <div class="col-md-3 pr-5">{{v.capacityLitres}} L</div>
                        <div class="col-md-3 pr-5">{{v.vehicleType}}&nbsp;</div>
                        <div class="col-md-3 pr-5">{{v.feeAmount | currency:false:'symbol':'0.2'}}&nbsp;</div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!vehicles || vehicles.length == 0">
                <div class="col">No active vehicles found</div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">Billing</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="row" *ngIf="vm.billingPeriods.length==0">
                <div class="col">No recent billing recorded</div>
            </div>

            <div *ngIf="vm.billingPeriods.length > 0">
                <div class="row" *ngFor="let b of vm.billingPeriods">
                    <div class="col-8 small mb-2">{{b.billingPeriod}}</div>
                    <div class="col-4 text-right"> {{b.amount | currency:false:'symbol':'0.2'}}</div>
                </div>
                <div class="row mt-2" *ngIf="vm.billingPeriodCount > 6">
                    <div class="col-8"></div>
                    <div class="col-4 text-right"><a routerLink="/app/billing">View All</a></div>
                </div>
            </div>

        </div>
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">This Month</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="row">
                <div class="col small mb-2">Device Usage</div>
                <div class="col text-right">{{vm.currentMonth.loggerUsage | currency:false:'symbol':'0.2'}}</div>
            </div>
            <div class="row">
                <div class="col small mb-2">EMS Usage</div>
                <div class="col text-right">{{vm.currentMonth.emsUsage | currency:false:'symbol':'0.2'}}</div>
            </div>
            <div class="row">
                <div class="col small mb-2">Manual Usage</div>
                <div class="col text-right">{{vm.currentMonth.manualUsage | currency:false:'symbol':'0.2'}}</div>
            </div>
            <div class="row">
                <div class="col small mb-2">Permit Fees</div>
                <div class="col text-right">{{vm.currentMonth.permitFee | currency:false:'symbol':'0.2'}}</div>
            </div>
            <div class="row" *ngIf="vm.currentMonth.rolledOver > 0">
                <div class="col small mb-2">Rolled over Сosts</div>
                <div class="col text-right">{{vm.currentMonth.rolledOver | currency:false:'symbol':'0.2'}}</div>
            </div>

            <div class="rates">
                <div class="row section-header  mt-4">
                    <div class="col">Current Rates</div>
                </div>
                <div>
                    <hr class="mt-0" />
                </div>
                <div class="d-flex">
                    <div class="mr-1 small mb-2">Permit Rate</div>
                    <div class="ml-auto" *ngIf="this.currentRate">{{currentRate.permitRate|
                        currency:false:'symbol':'0.2'}}</div>
                </div>
                <div class="d-flex">
                    <div class="mr-1 small mb-2">Usage Rate</div>
                    <div class="ml-auto" *ngIf="this.currentRate">{{currentRate.usageRate|
                        currency:false:'symbol':'0.2'}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">EMS Keys</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="row pb-2" *ngIf="!vm.emsKeys || vm.emsKeys.length==0">
                <div class="col">No EMS Keys issued</div>
            </div>
            <div class="row pb-2" *ngFor="let k of vm.emsKeys">
                <div class="col">{{k}}</div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">Hydrotrak App</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>
            <div class="row pb-2">
                <div class="col">
                    <a [href]="ios" target="_blank">
                        <img class="pr-3" src="assets/img/app-badge-ios.svg">
                    </a>
                    <a [href]="android" target="_blank">
                        <img src="assets/img/app-badge-android.png" width="130px">
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">Hydrant Locations</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>

            <div class="row pb-2">
                <div class="col">

                    <a href="https://ws.iota.net.au/HydroTrakHydrants/Home" target="_blank">
                        <img src="assets/img/Hydrotrak-Locations.PNG" style="width: 60%;height: auto;">
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row section-header  mt-4">
                <div class="col">Hydrant Operations</div>
            </div>
            <div>
                <hr class="mt-0" />
            </div>

            <div class="row pb-5">

                <div class="col-lg-4"><iframe width="350" height="198"
                        src="https://www.youtube-nocookie.com/embed/kNUBf7GMk9A" frameborder="0"
                        allowfullscreen></iframe></div>
            </div>
        </div>

    </div>

</div>
<cli-yes-cancel-modal #goRenewModal [id]="'goRenewModal'" [header]="'Renew Permit'"></cli-yes-cancel-modal>